import { RouteObject } from "react-router-dom";
import {
  Home,
  lazyLoad,
  Heanuser,
  HomePage,
  Heanmenu,
  Heanrole,
  Heanoperatelog,
  Stripeuser,
  Stripeurl,
  Stripeaccount,
  Stripechannel,
  Shippinginfo,
  Payoutinfo,
  Paymentrecord,
  Payoutinfodeduction,
  Stripeblacklist,

  Forget,
  Login,
  Register,
  Stripelog,
  Syncstripelog
} from "../pages";
export type IRouter = RouteObject & {};

export const mainRoutes: IRouter[] = [
  {
    path: "/",
    element: lazyLoad(<Home />),
    children: [
      {
        path: "/home/index/:homeview?",
        element: lazyLoad(<HomePage.Home />),
      },
      // 账号管理
      {
        path: "/heanuser/page/list",
        element: lazyLoad(<Heanuser.HeanuserList />),
      },
      // 权限管理
      {
        path: "/permission/menutree",
        element: lazyLoad(<Heanmenu.MenuTreeList />),
      },
      {
        path: "/permission/role",
        element: lazyLoad(<Heanrole.RoleList />),
      },

      //日志
      {
        path: "/log/operatelog/pagelist",
        element: lazyLoad(<Heanoperatelog.OperateLogPage />),
      },
      {
        path: "/log/loginlog/pagelist",
        element: lazyLoad(<Heanoperatelog.LoginLogPage />),
      },
      // 支付通道
      {
        path: "/payment/stripeuser/list",
        element: lazyLoad(<Stripeuser.StripeuserPage />),
      },
      {
        path: "/payment/stripeuser/createurl/:companyCode/:userId",
        element: lazyLoad(<Stripeuser.StripeuserCreateUrl />),
      },
      
      {
        path: "/payment/stripeurl/list",
        element: lazyLoad(<Stripeurl.StripeurlPage />),
      },
      {
        path: "/payment/stripeaccount/list",
        element: lazyLoad(<Stripeaccount.StripeaccountPage />),
      },

      {
        path: "/payment/stripechannel/list",
        element: lazyLoad(<Stripechannel.StripechannelPage />),
      },

      //订单信息
      {
        path: "/order/stripelog/list",
        element: lazyLoad(<Stripelog.StripelogPage />),
      },
      {
        path: "/order/deduction/list",
        element: lazyLoad(<Payoutinfodeduction.DeductionPage />),
      },  
      {
        path: "/order/syncstripelog/list",
        element: lazyLoad(<Syncstripelog.SyncstripelogPage />),
      },
      {
        path: "/order/shippinginfo/list",
        element: lazyLoad(<Shippinginfo.ShippinginfoPage />),
      },
      {
        path: "/order/stblack/list",
        element: lazyLoad(<Stripeblacklist.StBlackPage />),
      },

      

      

      //结算管理
      {
        path: "/settlement/manager/list",
        element: lazyLoad(<Payoutinfo.ManagerPage />),
      },
      {
        path: "/settlement/customer/list",
        element: lazyLoad(<Payoutinfo.CustomerPage />),
      },

      {
        path: "/settlement/opener/list",
        element: lazyLoad(<Payoutinfo.OpenerPage />),
      },

      {
        path: "/settlement/partner/list",
        element: lazyLoad(<Payoutinfo.PartnerPage />),
      },

      // 结算记录
      {
        path: "/settlement/paymentrecord/list",
        element: lazyLoad(<Paymentrecord.PaymentrecordPage />),
      }
    ],
  },
  {
    path: "/sign",
    children: [
      {
        path: "login",
        element: lazyLoad(<Login />),
      },
      {
        path: "register",
        element: lazyLoad(<Register />),
      },
      {
        path: "forget",
        element: lazyLoad(<Forget />),
      },
    ],
  },
];
